import React, { useState, useEffect } from 'react';
import { getFirestore, collection, addDoc, getDocs, doc, updateDoc, getDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import Footer from '../Components/footer';
import Navbar from '../Components/NavBarAirbnbStyle';
import IconSelector from '../Components/IconSelector';
import './createcoinpackage.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';
Modal.setAppElement('#root');

const db = getFirestore(appFirebase);

const CreateCoinPackage = () => {
  const [packageName, setPackageName] = useState('');
  const [coinAmount, setCoinAmount] = useState('');
  const [price, setPrice] = useState('');
  const [color, setColor] = useState('#ffffff'); // Estado para el color
  const [icon, setIcon] = useState(''); // Estado para el icono
  const [coinPackages, setCoinPackages] = useState([]);
  const [editingPackageId, setEditingPackageId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(() => {
    fetchCoinPackages();
  }, []);

  const fetchCoinPackages = async () => {
    const querySnapshot = await getDocs(collection(db, 'coinPackages'));
    const packages = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));
    setCoinPackages(packages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'coinPackages'), {
        packageName,
        coinAmount: parseInt(coinAmount, 10),
        price: parseFloat(price),
        color, // Guardar el color seleccionado
        icon, // Guardar el icono seleccionado
        active: true
      });
      toast.success("Paquete de monedas creado exitosamente.");

      setPackageName('');
      setCoinAmount('');
      setPrice('');
      setColor('#ffffff'); // Restablecer el color al valor predeterminado
      setIcon(''); // Restablecer el icono
      fetchCoinPackages();
    } catch (error) {
      toast.error("Error al crear el paquete de monedas.");

      console.log('Error al crear el paquete de monedas: ' + error.message);
    }
  };

  const handleEdit = (pkg) => {
    setEditingPackageId(pkg.id);
    setPackageName(pkg.packageName);
    setCoinAmount(pkg.coinAmount);
    setPrice(pkg.price);
    setColor(pkg.color);  // Cargar el color en el estado
    setIcon(pkg.icon);  // Asegúrate de que el icono se cargue en el estado
  };


  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!icon) {
      toast.error("Por favor selecciona un icono.");

      return;
    }

    try {
      const docRef = doc(db, 'coinPackages', editingPackageId);

      await updateDoc(docRef, {
        packageName,
        coinAmount: parseInt(coinAmount, 10),
        price: parseFloat(price),
        color, // Asegúrate de que el color se actualice en Firestore
        icon // Actualiza con el icono seleccionado
      });
      toast.success("Paquete de monedas actualizado exitosamente.");
      setPackageName('');
      setCoinAmount('');
      setPrice('');
      setColor('#ffffff'); // Restablece el estado del color
      setIcon(''); // Restablece el estado del icono
      setEditingPackageId(null);
      fetchCoinPackages();
    } catch (error) {
      toast.error("Error al actualizar el paquete de monedas.");

      console.log('Error al actualizar el paquete de monedas: ' + error.message);
    }
  };





  const handleToggleActive = async (pkg) => {
    try {
      const docRef = doc(db, 'coinPackages', pkg.id); // Referencia al documento del paquete en Firestore
      await updateDoc(docRef, {
        active: !pkg.active // Invierte el estado actual de 'active'
      });
      fetchCoinPackages(); // Refresca la lista de paquetes
    } catch (error) {
      toast.error("Error al actualizar el estado del paquete de monedas.");

      console.log('Error al actualizar el estado del paquete de monedas: ' + error.message);
    }
  };

 const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  return (
    <div>
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <ToastContainer />
      <br /><br />

      <div className="create-package-container">
        <button
          className="w-full btn"
          onClick={() => {
            setEditingPackageId(null); // <-- Esto asegura que no estás editando
            setPackageName('');
            setCoinAmount('');
            setPrice('');
            setColor('#ffffff');
            setIcon('');
            setModalOpen(true);
          }}
          style={{ right: '050px', marginBottom: '10px' }}
        >
          Crear Paquete
        </button>

        <div className="package-list p-4 bg-white rounded-xl shadow-md overflow-x-auto">
          <h2 className="text-2xl font-bold mb-4">Listado de Paquetes</h2>

          <table className="min-w-full border border-gray-300 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border text-left">Nombre</th>
                <th className="p-3 border text-left">Monedas</th>
                <th className="p-3 border text-left">Color</th>
                <th className="p-3 border text-left">Icono</th>
                <th className="p-3 border text-left">Precio</th>
                <th className="p-3 border text-left">Estado</th>
                <th className="p-3 border text-left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {coinPackages.map((pkg) => (
                <tr
                  key={pkg.id}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="p-3 border break-words">{pkg.packageName}</td>
                  <td className="p-3 border">{pkg.coinAmount}</td>
                  <td className="p-3 border">
                    <div className="color-box" style={{ backgroundColor: pkg.color }}></div>
                  </td>



                  <td className="p-3 border">
                    <i className={pkg.icon}></i>
                  </td>
                  <td className="p-3 border">${pkg.price}</td>
                  <td className="p-3 border">
                    <span
                      className={`px-2 py-1 rounded-full text-white text-xs ${pkg.active ? 'bg-green-500' : 'bg-red-500'
                        }`}
                    >
                      {pkg.active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td className="p-3 border space-x-3">
                    <button
                      onClick={() => {
                        handleEdit(pkg);
                        setModalOpen(true);
                      }}
                      className="text-blue-600 hover:text-blue-800"
                      title="Editar"
                    >
                      <i className="fas fa-edit"></i>
                    </button>

                    <button
                      onClick={() => handleToggleActive(pkg)}
                      title={pkg.active ? 'Desactivar' : 'Activar'}
                      className={`btn-toggle ${pkg.active ? 'active' : 'inactive'}`}
                    >
                      <i className={pkg.active ? 'fas fa-toggle-on' : 'fas fa-toggle-off'}></i>
                    </button>

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


      </div>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => {
          setModalOpen(false); setModalOpen(false);
        }}
        className="modal-container"
        overlayClassName="overlay-container"
        contentLabel="Modal"
      >
        <h2 className="card-title text-2xl font-bold">
          {editingPackageId ? 'Editar Paquete de Monedas' : 'Crear Paquete de Monedas'}
        </h2>
        <form className="form-container" onSubmit={editingPackageId ? handleUpdate : handleSubmit}>
          <div className="Campo">
            <label htmlFor="packageName">Nombre del Paquete</label>
            <input
              id="packageName"
              placeholder="Nombre del paquete"
              value={packageName}
              onChange={(e) => setPackageName(e.target.value)}
              required
            />
          </div>
          <div className="Campo">
            <label htmlFor="coinAmount">Cantidad de Monedas</label>
            <input
              id="coinAmount"
              type="number"
              placeholder="Cantidad de monedas"
              value={coinAmount}
              onChange={(e) => setCoinAmount(e.target.value)}
              required
            />
          </div>
          <div className="Campo">
            <label htmlFor="price">Precio</label>
            <input
              id="price"
              type="number"
              step="0.01"
              placeholder="Precio"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
            />
          </div>
          <div className="Campo picker">
            <label htmlFor="color">Color</label>
            <input
              id="color"
              type="color"
              className='color-picker'
              value={color}
              onChange={(e) => setColor(e.target.value)}
              required
            />
            <div
              style={{
                display: 'inline-block',
                width: '20px',
                height: '20px',
                backgroundColor: color,
                borderRadius: '4px',
                marginLeft: '10px',
                border: '1px solid #000', // Añadir un borde para que sea más visible
              }}
            ></div>
          </div>
          <div className="Campo">
            <IconSelector icon={icon} setIcon={setIcon} />
            <button type="submit" className="w-full btn">
              {editingPackageId ? 'Actualizar Paquete' : 'Crear Paquete'}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default CreateCoinPackage;
